import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import BedevPlay from './components/BedevPlay/BedevPlay';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <main>
              <Hero />
              {/* <Companies /> */}
              {/* <Testimonials /> */}
            </main>
          } />
          <Route path="/bedev-play" element={<BedevPlay />} />
        </Routes>
        {/* <Footer /> */}
      </div>
    </Router>
  );
}

export default App;
